import {c} from '/utils/log';

function pushDataLayer(e) {
    if(window.self === window.top) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(e);
    }
    else {
        parent.dataLayer = parent.dataLayer || [];
        parent.dataLayer.push(e);
    }
}

function pushEventAndProperties(event, eventCategory, eventAction, currentItem, pagePath) {
    const category = currentItem.categories.map((category) => category.slug).join();
    pushDataLayer({
        event: event,
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: currentItem && currentItem.title ? currentItem.title : 'No Title',
        jwplayerWidgetPage: pagePath,
        jwplayerWidgetTitle: currentItem && currentItem.title ? currentItem.title : 'No Title',
        channel: currentItem && currentItem.categories && currentItem.categories.length ? category : 'No Channel'
    });
}

export const onAutoStart = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerAutoPlayCount', 'video', 'autoplay', currentItem, pagePath);
}

export const onVideoLoad = (currentItem, pagePath, isWidget) => {
    const category = currentItem.categories.map((category) => category.slug).join();
    isWidget ?
        pushDataLayer({
            event: 'jwplayerWidget',
            jwplayerWidgetPage: pagePath,
            jwplayerWidgetTitle: currentItem && currentItem.title ? currentItem.title : 'No Title',
            channel: currentItem && currentItem.categories && currentItem.categories.length ? category : 'No Channel'
        }) : null;
    pushEventAndProperties('jwPlayerVideoLoad', 'video', 'load', currentItem, pagePath);
    // currentItem && currentItem.categories && currentItem.categories.length > 0 && currentItem.categories.forEach(category => {
    //     pushDataLayer({
    //         event: 'videoChannelEvent',
    //         channel:  category.slug
    //     })
    // });
}

export const onReady = (event) => {
    window.JWPlayerReady = true;
    window.IsAutoPlaySupported = true;
    if(!window.PlayerUnMuted)
        document.getElementById("unmute-button").style.display = 'inline';
}

export const onUnmute = (event) => {
    window.PlayerUnMuted = true;
    document.getElementById("unmute-button").style.display = 'none';
}

export const doUnMute = (playerId, e) => {
    if(window.JWPlayerReady){
        const player = window.jwplayer(playerId);
        player.setMute(false);
        window.PlayerUnMuted = true;
        e.target.style.display = 'none';
    }
}

export const onPlay = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerPlay', 'video', 'play', currentItem, pagePath);
}

export const onThreeSeconds = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerThreeSecondsView', 'video', 'viewed 3 seconds', currentItem, pagePath);
 }

export const onTenSeconds = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerTenSecondsView', 'video', 'viewed 10 seconds', currentItem, pagePath);
}

export const onThirtySeconds = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerThritySecondsView', 'video', 'viewed 30 seconds', currentItem, pagePath);
 }

export const onTwentyFivePercent = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerTwentyFivePercentWatched', 'video', 'watched 25%', currentItem, pagePath);
 }

export const onFiftyPercent = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerFiftyPercentWatched', 'video', 'watched 50%', currentItem, pagePath);
 }

export const onSeventyFivePercent = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerSeventyFivePercentWatched', 'video', 'watched 75%', currentItem, pagePath);
 }

export const onNinetyFivePercent = (currentItem, pagePath) => {
    pushEventAndProperties('jwPlayerNinetyFivePercentWatched', 'video', 'watched 95%', currentItem, pagePath);
 }

 export const onOneHundredPercent = (currentItem, pagePath) => {
    document.getElementById("unmute-button").style.display = 'none';
    pushEventAndProperties('jwPlayerOneHundredPercentWatched', 'video', 'end', currentItem, pagePath);
 }
